import React from 'react';

import HeaderNavComponent from '../header/HeaderNavComponent';
import FooterComponent from '../footer/FooterComponent';
import { BreadcrumbComponent } from '../breadcrumb/BreadcrumbComponent';

import { Template } from './TemplateStyle';

export const CategoryDirectoryTemplate = props => {
    return (
        <Template className="flex-container-v">
            <HeaderNavComponent />
            {React.cloneElement(props.children, {
                Breadcrumb: BreadcrumbComponent
            })}
            <FooterComponent />
        </Template>
    );
};



// WEBPACK FOOTER //
// ./src/components/template/CategoryDirectoryTemplate.js